import { SharedState } from '@trello/shared-state';

import type { PlannerPopoverScreenType } from './PlannerHeaderToolbar/CalendarsPopover/PlannerPopoverScreen';

// Shared state that holds the screen to navigate to,
// null when no screen is to be navigated to.
export const openSettingsPopoverState =
  new SharedState<PlannerPopoverScreenType | null>(null);
